import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Legacy path builder + navigation
 */


/**
 * For drill-down modal close behaviour
 */
export const useDrillDownModalOnClose = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const isServiceTrackingPage = location.pathname.includes('/reports/vehicle-servicing')
  const isKMTrackingPage = location.pathname.includes('/reports/km-tracking')
  const isRequestVariationSummaryPage = location.pathname.includes('/contract-variations')
  const isExceptionsPage = location.pathname.includes('/reports/fuel-exceptions')

  return () => {
    navigate(
      isServiceTrackingPage
        ? '/reports/vehicle-servicing'
        : isKMTrackingPage
          ? '/reports/km-tracking'
          : isExceptionsPage
            ? '/reports/fuel-exceptions'
            : isRequestVariationSummaryPage
              ? '/contract-variations'
              : '/fleet'
    )
  }
}
